let reviewsData = [];
  
class ReviewsCarousel {
  setReviews(reviews) {
  this.reviews = reviews;
  this.currentIndex = 0;
  this.renderReviews();
  }
  
  constructor() {
      this.currentIndex = 0;
      this.autoScrollInterval = null;
    
      const width = window.innerWidth;
      if (width >= 1400) {
          this.visibleCards = 4;
      } else if (width >= 1200) {
          this.visibleCards = 3;
      } else if (width >= 1024) {
          this.visibleCards = 2;
      } else {
          this.visibleCards = 1;
      }
      this.init();
      this.startAutoScroll();
  }
  init() {
    this.setupEventListeners();
    this.handleResize();
    window.addEventListener('resize', () => this.handleResize());
  }
  
  startAutoScroll() {
  this.autoScrollInterval = setInterval(() => {
    this.goToNext();
  }, 9000);
  }

stopAutoScroll() {
  clearInterval(this.autoScrollInterval);
}

  setupEventListeners() {
    const mobileNavLeft = document.getElementById('mobileNavLeft');
    const mobileNavRight = document.getElementById('mobileNavRight');
    const desktopNavLeft = document.getElementById('desktopNavLeft');
    const desktopNavRight = document.getElementById('desktopNavRight');
    const modalClose = document.getElementById('modalClose');
    const reviewModal = document.getElementById('reviewModal');

    if (mobileNavLeft) mobileNavLeft.addEventListener('click', () => { this.goToPrevious(); this.stopAutoScroll(); });
    if (mobileNavRight) mobileNavRight.addEventListener('click', () => { this.goToNext(); this.stopAutoScroll(); });
    if (desktopNavLeft) desktopNavLeft.addEventListener('click', () => { this.goToPrevious(); this.stopAutoScroll(); });
    if (desktopNavRight) desktopNavRight.addEventListener('click', () => { this.goToNext(); this.stopAutoScroll(); });

    if (modalClose) modalClose.addEventListener('click', () => this.closeModal());

    if (reviewModal) {
      reviewModal.addEventListener('click', (e) => {
        if (e.target.id === 'reviewModal') this.closeModal();
      });
    }
  }
  
  handleResize() {
    const width = window.innerWidth;
    let newVisibleCards;
    if (width >= 1400) {
        newVisibleCards = 4;
    } else if (width >= 1200) {
        newVisibleCards = 3;
    } else if (width >= 1024) {
        newVisibleCards = 2;
    } else {
        newVisibleCards = 1;
    }
    if (newVisibleCards !== this.visibleCards) {
      this.visibleCards = newVisibleCards;
      this.currentIndex = 0;
      this.renderReviews();
    }
  }
  createStars(rating, containerClass) {
    let starsHtml = '';
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        starsHtml += `<span class="star filled ${containerClass}">★</span>`;
      } else {
        starsHtml += `<span class="star empty ${containerClass}">★</span>`;
      }
    }
    return starsHtml;
  }
  truncateText(text, maxLength = 100) {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  }
  createReviewCard(review) {
    const isTextTruncated = review.text.length > 100;
    const displayText = this.truncateText(review.text);
    return `
      <div class="review-card">
        <div class="review-header">
          <div class="customer-name">${review.customerName}</div>
          <div class="review-stars">${this.createStars(review.rating, 'review-stars')}</div>
          ${review.verified ? `
            <div class="verified-badge">
              <span class="checkmark">✓</span>
              <span>Verified Customer</span>
            </div>
          ` : ''}
        </div>
        <div class="review-content">
          <div>
            <p class="review-text">${displayText}</p>
            ${isTextTruncated ? `
              <button class="read-more-btn" onclick="window.reviewsCarousel.showModal('${review.id}')">
                Read more
              </button>
            ` : ''}
          </div>
          <div class="review-location">${review.location}, ${review.date}</div>
        </div>
      </div>
    `;
  }
  renderReviews() {
    const visibleReviews = this.reviews.slice(this.currentIndex, this.currentIndex + this.visibleCards);
  
    // Mobile layout
    const mobileCard = document.getElementById('mobileReviewCard');
    if (mobileCard && visibleReviews[0]) {
      mobileCard.innerHTML = this.createReviewCard(visibleReviews[0]);
    }
  
    // Desktop layout
    const desktopContainer = document.getElementById('desktopReviewContainer');
    if (desktopContainer) {
      desktopContainer.innerHTML = visibleReviews.map(review => this.createReviewCard(review)).join('');
    }
  
    this.updateNavigationButtons();
  }

  updateNavigationButtons() {
    const canGoLeft = this.currentIndex > 0;
    const canGoRight = this.currentIndex < this.reviews.length - this.visibleCards;
    // Mobile buttons
    const mobileNavLeft = document.getElementById('mobileNavLeft');
    const mobileNavRight = document.getElementById('mobileNavRight');
    const desktopNavLeft = document.getElementById('desktopNavLeft');
    const desktopNavRight = document.getElementById('desktopNavRight');
    if (mobileNavLeft) mobileNavLeft.disabled = !canGoLeft;
    if (mobileNavRight) mobileNavRight.disabled = !canGoRight;
    if (desktopNavLeft) desktopNavLeft.disabled = !canGoLeft;
    if (desktopNavRight) desktopNavRight.disabled = !canGoRight;
  }
goToNext() {
  if (!this.reviews || !Array.isArray(this.reviews) || this.reviews.length === 0) return;

  const maxIndex = this.reviews.length - 1;

  if (this.currentIndex < maxIndex) {
    this.currentIndex = this.currentIndex + 1;
  } else {
    this.currentIndex = 0;
  }

  this.renderReviews();
}

goToPrevious() {
  if (!this.reviews || !Array.isArray(this.reviews) || this.reviews.length === 0) return;

  if (this.currentIndex > 0) {
    this.currentIndex = Math.max(0, this.currentIndex - 1);
    this.renderReviews();
  }
}

  
  showModal(reviewId) {
    const review = this.reviews.find(r => r.id === reviewId);
    if (!review) return;
    const modal = document.getElementById('reviewModal');
    const customerName = document.getElementById('modalCustomerName');
    const stars = document.getElementById('modalStars');
    const reviewText = document.getElementById('modalReviewText');
    const location = document.getElementById('modalLocation');
    const verifiedBadge = document.getElementById('modalVerified');
    if (customerName) customerName.textContent = review.customerName;
    if (stars) stars.innerHTML = this.createStars(review.rating, 'modal-stars');
    if (reviewText) reviewText.textContent = review.text;
    if (location) location.textContent = `${review.location}, ${review.date}`;
    if (verifiedBadge) verifiedBadge.style.display = review.verified ? 'flex' : 'none';
    if (modal) {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  }
  closeModal() {
    const modal = document.getElementById('reviewModal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  }
}
// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.reviewsCarousel = new ReviewsCarousel();

 
fetch('https://cdn.shopify.com/s/files/1/0504/7146/9237/files/reviews_woodpower.json?v=1751989535')
  .then(response => {
    console.log('Fetch response:', response);
    return response.json();
  })
  .then(data => {
    console.log('Loaded reviews:', data);
    window.reviewsCarousel.setReviews(data);
  })
  .catch(error => console.error('Error loading reviews:', error));

});